import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AddCategoryLayer from "../components/AddCategoryLayer";

export const AddCategory = () => {
  return (
    <MasterLayout>
      <AddCategoryLayer />
    </MasterLayout>
  );
};
